import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import ProjectQueueTaskGetRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskGetRequest';
import ProjectQueueTaskListRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListRequest';
import GetListByProjectIdRequest from '../../../projects/groups/i-service/model/queue-tasks/GetListByProjectIdRequest';
import ProjectQueueTaskCreateRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskCreateRequest';
import MoveQueueTaskRequest from '../../../projects/groups/i-service/model/queue-tasks/MoveQueueTaskRequest';
import QueueTaskUpdateNameRequest from '../../../projects/groups/i-service/model/queue-tasks/QueueTaskUpdateNameRequest';
import ProjectTaskQueueDeleteRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectTaskQueueDeleteRequest';
import GetQueueParentTaskRequest from '../../../projects/groups/i-service/model/queue-tasks/GetQueueParentTaskRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import ProjectQueueTaskGetResponse from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskGetResponse';
import ProjectQueueTaskListResponse from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListResponse';
import GetListByProjectIdResponse from '../../../projects/groups/i-service/model/queue-tasks/GetListByProjectIdResponse';
import ProjectQueueTaskListItem from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListItem';
import GetQueueParentTaskResponse from '../../../projects/groups/i-service/model/queue-tasks/GetQueueParentTaskResponse';
import ProjectQueueTaskCreateEventResponse from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskCreateEventResponse';
import ProjectQueueTaskUpdateNameEventResponse from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskUpdateNameEventResponse';
import OnDeleteQueueTaskEventResponse from '../../../projects/groups/i-service/model/queue-tasks/OnDeleteQueueTaskEventResponse';

/**
 * * Сервис управления очередь задачами
 */
export default class ProjectQueueTaskService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	/**
	 * * Заглушка на событие создание очереди задачи
	 */
	OnCreateQueueTaskEventEvent = new Events<WsResponseModelT<ProjectQueueTaskCreateEventResponse>>();
	/**
	 * * Заглушка на событие обновление название очереди задачи
	 */
	OnUpdateNameQueueTaskEventEvent = new Events<WsResponseModelT<ProjectQueueTaskUpdateNameEventResponse>>();
	/**
	 * * Заглушка на событие удаление очереди задачи
	 */
	OnDeleteQueueTaskEventEvent = new Events<WsResponseModelT<OnDeleteQueueTaskEventResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectQueueTaskService', 'OnCreateQueueTaskEvent', 'Main', (res: WsResponseModelT<ProjectQueueTaskCreateEventResponse>) => {
			self.OnCreateQueueTaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'OnUpdateNameQueueTaskEvent', 'Main', (res: WsResponseModelT<ProjectQueueTaskUpdateNameEventResponse>) => {
			self.OnUpdateNameQueueTaskEventEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'OnDeleteQueueTaskEvent', 'Main', (res: WsResponseModelT<OnDeleteQueueTaskEventResponse>) => {
			self.OnDeleteQueueTaskEventEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Получение информации об очереде задач
	 */
	async Get(request: ProjectQueueTaskGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'Get',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список очередей задач
	 */
	async GetList(request: ProjectQueueTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'GetList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка очередй по номеру проекта
	 */
	async GetListByProjectId(request: GetListByProjectIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'GetListByProjectId',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить очередь задач в проект
	 */
	async Create(request: ProjectQueueTaskCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'Create',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Перемещение группы
	 */
	async MoveQueueTask(request: MoveQueueTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'MoveQueueTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление название очереди задач
	 */
	async UpdateName(request: QueueTaskUpdateNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'UpdateName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить очередь задач из проекта
	 */
	async Delete(request: ProjectTaskQueueDeleteRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'Delete',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение родительской задачи по номеру очереди
	 */
	async GetQueueParentTask(request: GetQueueParentTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'GetQueueParentTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение информации об очереде задач
	 */
	async getAsync(request: ProjectQueueTaskGetRequest): Promise<ProjectQueueTaskGetResponse> {
		return new Promise<ProjectQueueTaskGetResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'Get',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectQueueTaskGetResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectQueueTaskGetResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список очередей задач
	 */
	async getListAsync(request: ProjectQueueTaskListRequest): Promise<ProjectQueueTaskListResponse> {
		return new Promise<ProjectQueueTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'GetList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectQueueTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectQueueTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка очередй по номеру проекта
	 */
	async getListByProjectIdAsync(request: GetListByProjectIdRequest): Promise<GetListByProjectIdResponse> {
		return new Promise<GetListByProjectIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'GetListByProjectId',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetListByProjectIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetListByProjectIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить очередь задач в проект
	 */
	async createAsync(request: ProjectQueueTaskCreateRequest): Promise<ProjectQueueTaskListItem> {
		return new Promise<ProjectQueueTaskListItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'Create',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectQueueTaskListItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectQueueTaskListItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Перемещение группы
	 */
	async moveQueueTaskAsync(request: MoveQueueTaskRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'MoveQueueTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление название очереди задач
	 */
	async updateNameAsync(request: QueueTaskUpdateNameRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'UpdateName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить очередь задач из проекта
	 */
	async deleteAsync(request: ProjectTaskQueueDeleteRequest): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'Delete',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение родительской задачи по номеру очереди
	 */
	async getQueueParentTaskAsync(request: GetQueueParentTaskRequest): Promise<GetQueueParentTaskResponse> {
		return new Promise<GetQueueParentTaskResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'GetQueueParentTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetQueueParentTaskResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetQueueParentTaskResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}